import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { IWorkerService } from '../../../models/worker-service.model';
import { WorkerServiceTermsComponent } from '../worker-service-terms/worker-service-terms.component';

@Component({
  selector: 'app-worker-service',
  templateUrl: './worker-service.component.html',
  styleUrls: ['./worker-service.component.scss'],
})
export class WorkerServiceComponent {
  // Service provide by the support worker
  @Input() service: IWorkerService;

  // Event Emitter for the Worker Service update.
  @Output() updatedWorkerService = new EventEmitter<IWorkerService>();

  constructor(public popoverCtrl: PopoverController) {}

  /**
   * toggle the service when change event emitted from the check button
   */
  toggleServiceSelection() {
    this.updatedWorkerService.emit(this.service);
  }

  /**
   * This function will show the details about service when the information(i) is clicked.
   */
  async showServiceDetail() {
    const popover = await this.popoverCtrl.create({
      component: WorkerServiceTermsComponent,
      translucent: true,
      componentProps: {
        information: this.service.information,
        dialog: this.service.dialog,
        serviceName: this.service.name,
      },
    });
    return await popover.present();
  }
}
